module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAAXNSR0IArs4c6QAAAMdJREFUKBV9kDsKwkAURWcUEiFYCKkkvVvQLEFsra1cgXuwcQ3uQlRwEdmClVhYB6zG8wLKy3y8cEje52Yy1zjn1iA6Q2YSYraXJbTtVngRQwNXyH0fvQM84Q7DrymjuEFgpKcN094HGea+MWWw2ilG6hOUUMAY3lBbax8848Iov9rCBkRVfFN1WZI7aF0ognB+Fob60hV1NJyUoUsJUzJV453Qi5WZn+pkQPPIcZJiC0FKpCbpreAFc1jIKSUsYUTjr9jZwewDQ4cWj2f/EY4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cancel.png
// module id = 21
// module chunks = 7